/* eslint-disable prettier/prettier */
<template>
  <div class="padding-10">
    <v-card class="pa-5">
      <v-form v-model="isValid" ref="form">
        <Form v-model="form"></Form>
      </v-form>
      <Footer :item="user" @update="update" @save="save"></Footer>
    </v-card>
  </div>
</template>

<script>
import Form from "./create/Form";
import Footer from "./create/Footer";
import { functions, auth, users } from "../../assets/js/firebase";
import { getDate } from "../../assets/js/common";
export default {
  components: {
    Footer,
    Form
  },
  data() {
    return {
      isValid: false,
      form: {
        phone: "",
        first_name: "",
        last_name: "",
        email: "",
        role: 2
      },
      user: {}
    };
  },
  methods: {
    async save() {
      const vm = this;
      try {
        let { isValid, form } = vm;
        vm.$refs.form.validate();
        if (!isValid) return;
        vm.$root.loader = true;
        let date = getDate();
        form.created_at = date;
        form.updated_at = date;
        form.updated_by = auth.currentUser.email;
        let { data } = await functions.httpsCallable("createUser")(form);
        let { message, status } = data;
        if (status) {
          await auth.sendPasswordResetEmail(form.email);
          vm.$router.replace("/users");
        }
        vm.$root.loader = false;
        vm.$root.alert(message);
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    async update() {
      const vm = this;
      try {
        let { isValid, form } = vm;
        vm.$refs.form.validate();
        if (!isValid) return;
        vm.$root.loader = true;
        let date = getDate();
        form.updated_at = date;
        form.updated_by = auth.currentUser.email;
        let { id } = vm.$route.params;
        await users.doc(id).update(form);
        vm.$root.loader = false;
        vm.$router.replace("/users");
        vm.$root.alert("User updated successfully");
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    async init() {
      const vm = this;
      let { name, params } = vm.$route;
      if (name === "user-update") {
        let { id } = params;
        vm.$root.loader = true;
        try {
          let user = await users.doc(id).get();
          vm.$root.loader = false;
          if (!user.exists) {
            vm.$root.alert("User not found");
            vm.$router.replace("/users");
            return;
          }
          let { first_name, last_name, email, phone, role } = user.data();
          vm.user = user.data();
          vm.user.id = user.id;
          vm.form = { first_name, last_name, email, phone, role };
        } catch (error) {
          vm.$root.loader = false;
          vm.$root.alert(error.message);
        }
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style></style>
